// src/Dashboard.js
import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import Products from "./Products";
import UsersDashboard from "./UsersDashboard";

export default function Dashboard() {
  const [view, setView] = useState("products");

  const logout = async () => {
    try {
      await signOut(auth);
      window.location.reload();
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  // تنسيق التبويب النشط
  const getButtonStyle = (tabName) => ({
    background: view === tabName ? "#3b82f6" : "white",
    color: view === tabName ? "white" : "#1e3a8a",
    border: `1px solid ${view === tabName ? "#3b82f6" : "#1e3a8a"}`,
    padding: "8px 16px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    transition: "0.2s",
  });

  return (
    <div style={{ minHeight: "100vh", background: "#f3f4f6", fontFamily: "Arial, sans-serif" }}>
      {/* Header */}
      <div
        style={{
          background: "#1e3a8a",
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
          flexWrap: "wrap",
        }}
      >
        <h1 style={{ margin: 0 }}>Admin Dashboard</h1>
        <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
          <button 
            onClick={() => setView("products")} 
            style={getButtonStyle("products")}
          >
            Products
          </button>
          <button 
            onClick={() => setView("users")} 
            style={getButtonStyle("users")}
          >
            Users Management
          </button>
          <button 
            onClick={logout} 
            style={{ 
              ...getButtonStyle("logout"),
              background: "#dc2626", 
              color: "white",
              border: "1px solid #dc2626"
            }}
          >
            Logout
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ padding: 24 }}>
        {view === "products" && <Products />}
        {view === "users" && <UsersDashboard />}
      </div>

      {/* Footer */}
      <div style={{
        padding: "16px 24px",
        background: "#1e3a8a",
        color: "white",
        textAlign: "center",
        marginTop: "auto"
      }}>
        <small>Admin Panel v1.0 • {new Date().getFullYear()}</small>
      </div>
    </div>
  );
}